<template>
  <v-container v-if="personal">
    <v-row justify="center">
      <v-col cols="12">
        <v-row>
          <v-col cols="2">
            <v-btn text @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
              Volver
            </v-btn>
          </v-col>
          <v-col cols="8">
            <personal-info-card-component
              :personal="personal"
              :getFullName="getFullName"
            ></personal-info-card-component>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-card class="card ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="font-weight-bold justify-center ui-module-titlebar">Registro de CUIP</v-card-title>
          <v-card-text>
            <v-form v-model="dictamenForm">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :value="getFullName(personal)"
                      readonly
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Nombre del personal"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="cuip"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      maxlength="20"
                      counter
                      :rules="nameRules"
                      validate-on-blur
                    >
                      <template v-slot:label>CUIP <span class="red--text">*</span> </template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center pb-8 ui-module-actions">
            <TextButton
              color="secondary"
              class="px-8 ui-module-btn-solid"
              :loading="loading"
              :disabled="!dictamenForm || loading"
              v-on:click="triggerSaveCuip()"
              >Guardar cambios en personal</TextButton
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import sha1 from 'sha1'
import PersonalInfoCardComponent from '../../components/PersonalInfoCardComponent.vue'
import Notificacion from '@/modules/notificaciones/domain/Notificacion'
import { NotificationFactory, NOTIFICATION_TYPES } from '@/modules/notificaciones/domain/NotificationFactory'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    PersonalInfoCardComponent,
    TextButton,
  },

  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    await this.fetchPersonalById(this.id)
  },

  data() {
    return {
      loading: false,
      dictamenForm: false,
      menu: false,
      file: null,
      cuip: '',

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
  },

  methods: {
    ...mapActions('cuip', ['saveCuip']),
    ...mapActions('personal', ['uploadFoto', 'fetchPersonalById']),
    ...mapActions('preaspirante', ['fetchAspirantes']),
    ...mapActions('usuario', ['saveUsuario']),
    ...mapMutations('personal', ['SET_PERSONAL_FOTO_CUIP']),
    ...mapActions('notificaciones', ['createNotification']),

    triggerSaveCuip: async function () {
      this.loading = true

      try {
        await this.saveCuip({
          idPersonal: this.id,
          cuip: this.cuip,
        })

        await this.saveUsuario({
          fk_idPersonal: this.id,
          loginField: this.cuip,
          newPassword: sha1(this.cuip).toUpperCase(),
          withTwoFactor: false,
        })

        await this.sendNotification()
        await this.fetchAspirantes()

        this.$router.go(-1)
      } catch (error) {
        console.error('Error al guardar el CUIP:', error)
      } finally {
        this.loading = false
      }
    },
    async sendNotification() {
      try {
        const notification = new NotificationFactory(Notificacion).createNotification(
          NOTIFICATION_TYPES.REGISTRO_CUIP,
          {
            responsable: Number(localStorage.getItem('idPersonal')),
            afectado: this.id,
            nombrePersonal: this.getFullName(this.personal),
            cuip: this.cuip,
          }
        )

        await this.createNotification(notification)
      } catch (error) {
        console.error('Error al enviar la notificación:', error)
      }
    },

    getFullName(personal) {
      if (!personal) return ''
      const nombre = personal.nombre || ''
      const segundoNombre = personal.segundoNombre || ''
      const apellidoPaterno = personal.apaterno || personal.apellidoPaterno || ''
      const apellidoMaterno = personal.amaterno || personal.apellidoMaterno || ''
      return `${nombre} ${segundoNombre} ${apellidoPaterno} ${apellidoMaterno}`.trim()
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para Registro de Foto y CUIP */
.card::v-deep .v-card__title {
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.15) !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  color: #e0e0e0 !important;
}

.card::v-deep .v-card__text {
  padding: 24px !important;
  background: transparent !important;
}

/* Botones modernos */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative !important;
  overflow: hidden !important;
}

::v-deep .v-btn:hover:not(:disabled):not(.v-btn--text) {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

::v-deep .v-btn.v-btn--has-bg.secondary {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb), 0.4) !important;
}

::v-deep .v-btn.secondary:not(.v-btn--text) {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb), 0.4) !important;
}

::v-deep .v-btn--text {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-btn--text:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.1) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease !important;
  color: inherit !important;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.1) !important;
}

/* Input fields */
::v-deep .v-text-field.v-text-field--filled > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-text-field.v-text-field--filled:hover > .v-input__control > .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  background: rgba(0, 0, 0, 0.4) !important;
}

::v-deep .v-input--is-focused.v-text-field--filled > .v-input__control > .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.15) !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

::v-deep .v-text-field--filled .v-text-field__slot input {
  color: #e0e0e0 !important;
}

::v-deep .v-text-field--filled .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}

::v-deep .v-input--is-focused .v-icon {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-counter {
  color: rgba(224, 224, 224, 0.6) !important;
}

/* Textos */
.text-caption,
.text-subtitle-1 {
  color: #e0e0e0 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb), 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.6);
}
</style>
